import { getCookie } from "./cookie";
import { getCurrentUser } from "./shared";
import { ADMIN_ROLE, UNKNOWN_ROLE } from "./constants";

let redirected = false;

export const isAnonymousUser = () => {
  const user = getCurrentUser();

  const userRole = Symbol.for(user.role);

  return userRole === UNKNOWN_ROLE;
};

// redirect to login if auth is expired
export const redirectIfAuthExpired = returnRoute => {
  if (redirected) {
    console.log(
      "page is being redirected, skip route redirect: ",
      returnRoute.fullPath
    );
    return;
  }

  let noRole = !returnRoute || !returnRoute.meta || !returnRoute.meta.role;
  let noPermission =
    !returnRoute ||
    !returnRoute.meta ||
    !returnRoute.meta.navbarMenu ||
    !returnRoute.meta.navbarMenu.permission;
  //If they are visiting a page that doesn't require login, don't kick them out
  if (noRole && noPermission) {
    return;
  }

  const authExpireTimeStamp = getCookie("proteus_auth_expire");
  if (
    !authExpireTimeStamp ||
    parseInt(authExpireTimeStamp) < new Date().getTime()
  ) {
    console.log("Authorization expired. Redirect to login");

    // using vendor login for all type of user isn't ideal, however it works. We don't have other options either because we don't really know what kind of user it is since the user isn't logged in in the first place.
    window.location = `/v2/#/vendor/login`;
    location.reload();
    // first redirect wins, and once redirected there is no going back
    redirected = true;
    return true;
  }
  return false;
};

const hasRole = (user, roles) => {
  if (!roles) return true;

  const routeRoles = Array.isArray(roles) ? roles : [roles];

  if (routeRoles.length === 0) return true;

  // for protected route, always return false when no logged in user found
  if (!user) return false;

  var userRole = Symbol.for(user.role);

  //The user can have any of the roles listed
  return userRole === ADMIN_ROLE || routeRoles.includes(userRole);
};

const hasPermissions = (user, requiredPermissions) => {
  // for non protected route, always return true
  if (!requiredPermissions) return true;

  if (!user) return false;

  let missingAnyPermission =
    Object.entries(requiredPermissions)
      .map(arr => ({ key: arr[0], requiredValue: arr[1] }))
      .filter(perm => user["has" + perm.key] !== perm.requiredValue).length > 0;

  return !missingAnyPermission;
};

export const hasPermission = (permission, roles) => {
  const user = getCurrentUser();
  return hasPermissions(user, permission) && hasRole(user, roles);
};
